"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var S = _interopRequireWildcard(require("./wsPreviewStyle"));
var _closeButton = _interopRequireDefault(require("./close-button.svg"));
var _state = require("printableWorksheets/state");
var _events = _interopRequireDefault(require("printableWorksheets/events"));
var _common = require("apps/teacher/config/common");
var _constants = require("printableWorksheets/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var WSPreview = function WSPreview(props) {
  var _props$worksheetDetai, _props$worksheetDetai2, _props$worksheetDetai3, _props$worksheetDetai4, _props$worksheetDetai5;
  var _usePrintableWorkshee = (0, _state.usePrintableWorksheetsState)(),
    userId = _usePrintableWorkshee.userId;
  var overlayRef = (0, _react.useRef)(null);
  var gradesAndStandard = (_props$worksheetDetai = props.worksheetDetails) === null || _props$worksheetDetai === void 0 ? void 0 : _props$worksheetDetai.grades;
  var subjectsAndTopics = (_props$worksheetDetai2 = props.worksheetDetails) === null || _props$worksheetDetai2 === void 0 ? void 0 : _props$worksheetDetai2.subject_and_topics;
  var wsDownloadLeft = JSON.parse(localStorage.getItem('free_ws_download_left'));
  var isUserSubscribed = JSON.parse(localStorage.getItem('is_user_subscribed'));
  var popupCloseHandler = function popupCloseHandler() {
    document.querySelector('#ws-preview-wrapper').classList.add('slide-down');
    setTimeout(function () {
      var _window$parent;
      var eventProps = {
        clickedOn: 'Close',
        freeWorksheetsLeftCount: (0, _common.freeWsDownloadLeft)()
      };
      _events["default"].interactedWorksheetPreview(eventProps);
      props.setShowWorksheetPreview(false);
      if ((_window$parent = window.parent) !== null && _window$parent !== void 0 && _window$parent.triggerIsFlutterHeaderClickDisabled) {
        window.parent.triggerIsFlutterHeaderClickDisabled();
      }
      /// if preview popup is closed then again set overflow properties in parent. (Safari/Firefox browser issue fix)
      var worksheetsRightDiv = window.document.getElementById('ws-right-div');
      worksheetsRightDiv.style.overflowX = 'hidden';
      worksheetsRightDiv.style.overflowY = 'overflow';

      // delete key after WS preview is shown via signup from WS Detail pages
      localStorage.removeItem('viaWsOnboarding');
    }, 300);
  };

  // If clicked outside of PreviewWrapper, close the popup
  var handleClickOutside = function handleClickOutside(event) {
    if (overlayRef.current && !overlayRef.current.contains(event.target)) {
      popupCloseHandler();
    }
  };

  // Function to close the preview popup
  var closePreviewPopup = function closePreviewPopup() {
    props.setShowWorksheetPreview(false);
  };
  function handlePreviewPopupClose() {
    closePreviewPopup(); // Update the state to close the popup
  }
  (0, _react.useEffect)(function () {
    var props = {
      from: (0, _common.hasSignedUpFromWs)() ? 'Onboarding' : 'Printables Tab',
      freeWorksheetsLeftCount: (0, _common.freeWsDownloadLeft)()
    };
    _events["default"].viewedWorksheetPreview(props);
    document.addEventListener('mousedown', handleClickOutside);

    // Add an event listener to listen for the custom event dispatched from web-ui repo and re-render the component
    window.parent.parent.addEventListener('closePreviewPopup', handlePreviewPopupClose);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
      window.parent.parent.removeEventListener('closePreviewPopup', handlePreviewPopupClose);
    };
  }, []);
  var downloadWorksheet = function downloadWorksheet(e, from) {
    e.preventDefault();
    if (props.worksheetDetails.id && userId && (0, _common.canDownloadWs)()) {
      fetch(props.worksheetDetails.pdf_url, {
        credentials: 'omit'
      }).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        // Open WS pdf in new tab
        var isChromeBrowser = navigator.userAgent.includes("Chrome");
        // setTimeout is used for Safari browser as pdf was not opening in next window. On chrome, setTimeout is blocking new window popup
        isChromeBrowser ? window.open(props.worksheetDetails.pdf_url, '_blank') : setTimeout(function () {
          window.open(props.worksheetDetails.pdf_url, '_blank');
        });
        var eventProps = {
          clickedOn: from,
          freeWorksheetsLeftCount: (0, _common.freeWsDownloadLeft)()
        };
        _events["default"].interactedWorksheetPreview(eventProps);
        _events["default"].downloadedWorksheetB2c({
          worksheetName: props.worksheetDetails.title,
          worksheetCode: props.worksheetDetails.code
        });
        !isUserSubscribed && wsDownloadLeft > 0 && localStorage.setItem('free_ws_download_left', JSON.stringify(wsDownloadLeft - 1));
        // sending this event from FE as worksheet download handling is done on FE only.
        if (localStorage.getItem('free_ws_download_left') === "0" && !isUserSubscribed) {
          _events["default"].reachedDailyLimitBackend({
            contentName: props.worksheetDetails.title,
            contentCode: props.worksheetDetails.code,
            contentType: "worksheets",
            from: "Worksheets"
          });
        }
        props.setShowWorksheetPreview(false);
        if (window.parent.triggerIsFlutterHeaderClickDisabled) {
          window.parent.triggerIsFlutterHeaderClickDisabled();
        }
        // delete key after WS preview is shown via signup from WS Detail pages
        localStorage.removeItem('viaWsOnboarding');

        // Using window.parent.parent.location.reload() for flutter users -> There are 2 top layers - React(web-ui) -> Flutter -> React(school-ui)
        (0, _common.isFlutterUser)() ? reloadFlutter() : window.location.reload();
      })["catch"](function (error) {
        console.log(error);
      });
    }
  };
  var reloadFlutter = function reloadFlutter() {
    // used window.parent.parent because Printables is opened in webview. There are 2 top layers above it.
    window.parent.parent.location.reload();
  };
  var redirectToPurchase = function redirectToPurchase() {
    (0, _common.isFlutterUser)() ? window.parent.parent.location.href = '/dashboard#/purchase?source=printables&limit=0' : location.hash = '/purchase?source=printables&limit=0';
  };
  return /*#__PURE__*/_react["default"].createElement(S.PreviewOverlay, {
    "data-sentry-element": "unknown",
    "data-sentry-component": "WSPreview",
    "data-sentry-source-file": "wsPreview.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.PreviewWrapper, {
    id: "ws-preview-wrapper",
    isOpen: props.showWorksheetPreview,
    ref: overlayRef,
    isFlutterUser: (0, _common.isFlutterUser)(),
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsPreview.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.CloseButton, {
    onClick: popupCloseHandler,
    isOpen: props.showWorksheetPreview,
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsPreview.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_closeButton["default"], {
    "data-sentry-element": "CloseButton",
    "data-sentry-source-file": "wsPreview.tsx"
  }), /*#__PURE__*/_react["default"].createElement(S.ButtonText, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsPreview.tsx"
  }, "Close Preview")), /*#__PURE__*/_react["default"].createElement(S.WSDetails, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsPreview.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.WSTextWrapper, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsPreview.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.WSTitle, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsPreview.tsx"
  }, (_props$worksheetDetai3 = props.worksheetDetails) === null || _props$worksheetDetai3 === void 0 ? void 0 : _props$worksheetDetai3.title), /*#__PURE__*/_react["default"].createElement(S.WSDescription, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsPreview.tsx"
  }, (_props$worksheetDetai4 = props.worksheetDetails) === null || _props$worksheetDetai4 === void 0 ? void 0 : _props$worksheetDetai4.description), JSON.parse(localStorage.getItem('showWsCountText')) && /*#__PURE__*/_react["default"].createElement(S.FreeWSCount, null, "You have ", JSON.parse((0, _common.freeWsDownloadLeft)() || '0'), " of ", (0, _common.totalWsDownloadCount)(), " free worksheets left for today"), props.showUnlockButton ? /*#__PURE__*/_react["default"].createElement(S.CtaButton, {
    onClick: function onClick() {
      return redirectToPurchase();
    }
  }, "Start free trial to unlock") : /*#__PURE__*/_react["default"].createElement(S.CtaButton, {
    onClick: function onClick(e) {
      return downloadWorksheet(e, 'Print CTA');
    }
  }, "Print worksheet"), /*#__PURE__*/_react["default"].createElement(S.TagsCategory, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsPreview.tsx"
  }, "GRADE & STANDARD"), /*#__PURE__*/_react["default"].createElement(S.TagsWrapper, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsPreview.tsx"
  }, gradesAndStandard === null || gradesAndStandard === void 0 ? void 0 : gradesAndStandard.map(function (name, index) {
    return /*#__PURE__*/_react["default"].createElement(S.TagName, {
      key: index
    }, JSON.parse(localStorage.getItem('viaWsOnboarding')) ? name : _constants.GRADE_TITLE_MAP[name]);
  })), /*#__PURE__*/_react["default"].createElement(S.TagsCategory, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsPreview.tsx"
  }, "SUBJECTS & TOPICS"), /*#__PURE__*/_react["default"].createElement(S.TagsWrapper, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsPreview.tsx"
  }, subjectsAndTopics === null || subjectsAndTopics === void 0 ? void 0 : subjectsAndTopics.map(function (name, index) {
    return /*#__PURE__*/_react["default"].createElement(S.TagName, {
      key: index
    }, name);
  }))), /*#__PURE__*/_react["default"].createElement(S.WSImageWrapper, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsPreview.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.WSImage, {
    onClick: function onClick(e) {
      return downloadWorksheet(e, 'Thumbnail');
    },
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsPreview.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.ImageOverlay, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsPreview.tsx"
  }), /*#__PURE__*/_react["default"].createElement("img", {
    src: (_props$worksheetDetai5 = props.worksheetDetails) === null || _props$worksheetDetai5 === void 0 ? void 0 : _props$worksheetDetai5.image_url,
    alt: "worksheetImage"
  }))))));
};
var _default = exports["default"] = WSPreview;